module.exports = __webpack_public_path__ + "img/platform5.2a2941c2.png";